export default {
  content: "",
  error: false,
  filename: "",
};
